<xpo-shell class="app-obi-container">
  <xpo-header-app-name>Edge</xpo-header-app-name>
  <xpo-header-sub-app-name class="sub-app-container">OBI <span *ngIf="!isProduction"> <mat-chip xpoBadgeChipNegative
        class="sub-header-chip">{{
        this.region }}</mat-chip>
    </span> </xpo-header-sub-app-name>
  <xpo-header-navigation>
    <button *ngIf="isMenuAllowed(menuItems.offBillIncentiveList)" routerLink="/off-bill-incentive/list-page"
      routerLinkActive="xpo-selected">
      Off Bill Incentive List
    </button>
    <button *ngIf="isMenuAllowed(menuItems.agreementList)" routerLink="/obi-agreement/list-page"
      routerLinkActive="xpo-selected">
      Agreement List
    </button>
  </xpo-header-navigation>
  <xpo-header-utilities-actions>
    <button xpo-action-button (click)="openRamRolesSwitchDialog()" *ngIf="!isProduction" class="action-btn"
      matTooltip="Switch RAM Roles" matTooltipPosition="below">
      <xpo-icon iconName="settings" class="settings-btn"></xpo-icon>
    </button>
    <button xpo-action-button [matMenuTriggerFor]="appLinksMenu" matTooltip="Additional Links"
      matTooltipPosition="below" class="action-btn">
      <xpo-icon iconName="tools" class="settings-btn"></xpo-icon>
    </button>
    <app-notification-menu *ngIf="populateAccountPopover()"> </app-notification-menu>
    <xpo-auth-user-profile> </xpo-auth-user-profile>
  </xpo-header-utilities-actions>
  <mat-menu #appLinksMenu="matMenu" class="app-links-menu">
    <div class="profile-link">
      <a [href]="lookerReportURL" target="_blank">Looker Shipment Report</a>
      <a [href]="customerBaseURL" target="_blank">Edge Customer Base</a>
      <a [href]="shipmentManagementURL" target="_blank">Edge Shipment Management</a>
      <a [href]="ratingURL" target="_blank">Edge Rating Analysis</a>
    </div>

  </mat-menu>
  <router-outlet></router-outlet>
</xpo-shell>
<xpo-footer xpoFooterSticky [version]="appVersion">
  <div>
    <a [href]="releaseNotesURL" target="_blank">Release Notes</a>
  </div>
</xpo-footer>

<app-notification></app-notification>
